import "react";
import { ColorSquare } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/Select/SelectGroupListItem.tsx
var SelectGroupListItem = ({ color, label }) => /* @__PURE__ */ jsxs("div", {
	className: "inline-flex w-full items-center justify-between",
	children: [/* @__PURE__ */ jsx("span", {
		className: "truncate",
		children: label
	}), !!color && /* @__PURE__ */ jsx(ColorSquare, { color })]
});
export { SelectGroupListItem };

//# sourceMappingURL=SelectGroupListItem.js.map